import Input from "../../../../components/FormComponents/Input";

const SmtpConfig = ({ data, onChange }) => {
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    onChange({ ...data, [name]: value });
  };

  return (
    <div className={"d_flex flex_column gap_3"}>
      <Input
        name="smtp_host"
        value={data.smtp_host}
        onChange={handleInputChange}
        placeholder="SMTP Host (e.g., smtp.gmail.com)"
        label="SMTP Host"
      />
      <Input
        name="smtp_port"
        value={data.smtp_port}
        onChange={handleInputChange}
        placeholder="SMTP Port (e.g., 587)"
        label="SMTP Port"
      />
      <Input
        name="smtp_username"
        value={data.smtp_username}
        onChange={handleInputChange}
        placeholder="Your SMTP Username"
        label="SMTP Username"
      />
      <Input
        name="smtp_password"
        value={data.smtp_password}
        onChange={handleInputChange}
        placeholder="Your SMTP Password"
        label="SMTP Password"
        type="password"
      />
    </div>
  );
};
export default SmtpConfig;
